import React from 'react';
import { css } from '@emotion/react';
import NavResponsiveModal, { ModalHeader } from '@/components/Navigation/NavResponsiveModal';
import { ModalContent, GreyBody } from '@/styles/blocks';
import IntegrationRow from './IntegrationRow';

const IntegrationsModal = ({ open, onClose, integrations = [], shipperName }) => {
    return (
        <NavResponsiveModal open={open} onClose={onClose} maxWidth="md" fullWidth>
            <ModalHeader
                title={`Integrations${shipperName ? ` — ${shipperName}` : ''}`}
                onClose={onClose}
                css={css`
                    border-bottom: 1px solid lightgray;
                `}
            />
            <ModalContent
                css={css`
                    width: 100%;
                `}
            >
                {integrations.length === 0 ? (
                    <GreyBody>No integrations configured for this shipper.</GreyBody>
                ) : (
                    integrations.map((integration) => (
                        <IntegrationRow key={integration.override_id} integration={integration} />
                    ))
                )}
            </ModalContent>
        </NavResponsiveModal>
    );
};

export default IntegrationsModal;
